module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.visible) ? _c('div', {
    staticClass: "container"
  }, [_c('ReportWorkButton', {
    on: {
      "newReport": _vm.addReport,
      "finishedReport": _vm.finishReport
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row mt-3"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-3"
  }, [_c('div', {
    staticClass: "box-bordered o-f-h p-10 m-b-30"
  }, [_c('AddReport', {
    on: {
      "created": _vm.fetchData
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 col-lg-9"
  }, [_c('div', {
    staticClass: "box-bordered p-10"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.fetchData.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "input-group mb-3"
  }, [_c('div', {
    staticClass: "input-group-prepend"
  }, [_c('vs-tooltip', {
    attrs: {
      "text": "Data początkowa"
    }
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("today")])])])], 1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dateFrom),
      expression: "dateFrom"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date",
      "id": "form-date-from",
      "max": "9999-12-31",
      "required": ""
    },
    domProps: {
      "value": (_vm.dateFrom)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dateFrom = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "input-group mb-3"
  }, [_c('div', {
    staticClass: "input-group-prepend"
  }, [_c('vs-tooltip', {
    attrs: {
      "text": "Data końcowa"
    }
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("event")])])])], 1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dateTo),
      expression: "dateTo"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date",
      "id": "form-date-to",
      "max": "9999-12-31",
      "required": ""
    },
    domProps: {
      "value": (_vm.dateTo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dateTo = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "input-group mb-3"
  }, [_c('div', {
    staticClass: "input-group-prepend"
  }, [_c('vs-tooltip', {
    attrs: {
      "text": "Łączny przepracowany czas w podanym przedziale dat"
    }
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("history")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-control"
  }, [_vm._v("\n                                    " + _vm._s(_vm.elapsedTime) + "\n                                ")])])]), _vm._v(" "), _c('button', {
    ref: "submitButton",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "submit"
    }
  })])]), _vm._v(" "), (_vm.data.results) ? _c('div', [_c('table', {
    staticClass: "table"
  }, [_vm._m(0), _vm._v(" "), _c('transition-group', {
    attrs: {
      "name": "report-list",
      "tag": "tbody"
    }
  }, [(_vm.data.results.length) ? _vm._l((_vm.data.results), function(report, idx) {
    return _c('tr', {
      key: report.id,
      staticClass: "report-list-item",
      style: ({
        'background-color': _vm.getStyle(report)
      }),
      on: {
        "mouseover": function($event) {
          _vm.whereDeleteButton = idx
        },
        "mouseleave": function($event) {
          _vm.whereDeleteButton = -1
        }
      }
    }, [(report.id === 'empty') ? [_c('td', {
      attrs: {
        "colspan": "6"
      }
    }, [_c('br')])] : [_c('td', [_vm._v(_vm._s(_vm.formatDate(report.on_date)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.minutesToTime(report.from_hour)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.minutesToTime(report.to_hour)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.periodOfTime(report.from_hour, report.to_hour)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getPlace(report.place)))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "close",
      style: ({
        visibility: idx === _vm.whereDeleteButton ? 'visible' : 'hidden'
      }),
      attrs: {
        "type": "button",
        "aria-label": "Close",
        "data-toggle": "modal",
        "data-target": '#delete-report-button-' + report.id
      }
    }, [_c('span', {
      attrs: {
        "aria-hidden": "true"
      }
    }, [_vm._v("×")])]), _vm._v(" "), _c('ConfirmCancelReservation', {
      attrs: {
        "id": 'delete-report-button-' + report.id
      },
      on: {
        "yes": function($event) {
          return _vm.deleteReport(report.id)
        },
        "no": function () {}
      }
    }, [_c('h6', {
      attrs: {
        "slot": "body"
      },
      slot: "body"
    }, [_vm._v("\n                                                    Czy na pewno chcesz usunąć raport od " + _vm._s(_vm.minutesToTime(report.from_hour)) + "\n                                                    do " + _vm._s(_vm.minutesToTime(report.to_hour)) + "\n                                                    z dnia " + _vm._s(_vm.formatDate(report.on_date)) + "?\n                                                ")])])], 1)]], 2)
  }) : _c('tr', {
    key: 'no-data',
    staticClass: "table-secondary"
  }, [_c('td', {
    attrs: {
      "colspan": "6"
    }
  }, [_vm._v("Brak danych")])])], 2)], 1), _vm._v(" "), (_vm.showPagination) ? _c('vs-pagination', {
    ref: 'pagination',
    attrs: {
      "max": _vm.pagination_max,
      "total": _vm.data.pages
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  }) : _vm._e()], 1) : _vm._e()])])])], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Dzień")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Początek")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Koniec")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Czas")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Miejsce")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "30px"
    }
  })]), _c('tr')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-747e2aaa!./~/vue-loader/lib/selector.js?type=template&index=0!./app/components/ia/ReportHistoryView.vue
// module id = 1103
// module chunks = 0